<template>
  <div class="announcement-card" :data-announcement-id="announcement.id" :data-isread="announcement.isRead ? 'true' : 'false'"
    role="button" tabindex="0" @click="$emit('open', announcement)"
    @keydown.enter.prevent="$emit('open', announcement)" @keydown.space.prevent="$emit('open', announcement)">
    <div class="card-top">
      <div class="type-badge" :class="isCourseScope ? 'scope-course' : 'scope-global'">
        <span class="scope-badge-icon"></span>
        <span class="badge-label">{{ scopeLabel }}</span>
      </div>
      <span v-if="!announcement.isRead" class="unread-badge">Unread</span>
    </div>

    <div class="details">
      <h4>{{ announcement.title }}</h4>
      <div class="announcement-date">{{ formattedDate }}</div>
    </div>
  </div>
</template>

<script>
import { AnnouncementScope } from '../../constants/announcement';

export default {
  name: 'AnnouncementCard',
  props: {
    announcement: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return this.formatDate(this.announcement.date);
    },
    isCourseScope() {
      return String(this.announcement.entityType || '').toLowerCase() === AnnouncementScope.ProductVariant.toLowerCase();
    },
    scopeLabel() {
      return this.isCourseScope ? 'Course' : 'Global';
    },
  },
  methods: {
    formatDate(dateString) {
      const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      return new Date(dateString).toLocaleString('en-US', options);
    },
  },
};
</script>

<style scoped>
.announcement-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
}

.announcement-card:hover {
  background: #e9e9e9;
}

.card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
}

.type-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid transparent;
}

.type-badge.scope-global {
  background-color: #eef2ff;
  color: #4338ca;
  border-color: #c7d2fe;
}

.type-badge.scope-course {
  background-color: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.unread-badge {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: red;
  color: #fff;
}

.scope-badge-icon {
  display: inline-block;
  width: 11px;
  height: 11px;
  margin-right: 4px;
  background-color: currentColor;
  -webkit-mask: url("~@/assets/images/announcement-scope.svg") no-repeat center / contain;
  mask: url("~@/assets/images/announcement-scope.svg") no-repeat center / contain;
}

.badge-label {
  text-transform: uppercase;
  font-size: 8px;
  font-weight: 600;
}

.details {
  color: #333;
}

.details h4 {
  margin: 0 0 4px 0;
  font-size: 1.2rem;
  color: #000;
}

.announcement-date {
  font-size: 10px;
  color: #888;
}

@media (max-width: 600px) {
  .announcement-card {
    padding: 10px;
  }

  .badge-label {
    font-size: 7px;
  }

  .details h4 {
    font-size: 0.7rem;
  }
}
</style>
